<template>
  <div class="ui-text-l flex max-w-[563px] flex-col items-start gap-4">
    <NuxtLink
      :to="
        blog?.slug
          ? localePath(
              `/blog/${blog?.categories[0]?.slug || 'all'}/${blog.slug}`,
            )
          : undefined
      "
      class="w-full"
      :aria-label="blog.currentTranslation?.title"
    >
      <UiLazyImg
        class="aspect-h-[184] aspect-w-[408] sm:aspect-h-[274]"
        :cover="true"
        :alt="image?.alt || blog.currentTranslation?.title || $t('image')"
        :src="image?.file?.url || recoverPasswordImage"
      />
    </NuxtLink>
    <div class="ui-text-m text-gray-light-2">{{ publishedAt }}</div>
    <div class="flex flex-col gap-2.5">
      <span class="ui-h4 text-black">
        <NuxtLink
          :to="
            blog?.slug
              ? localePath(
                  `/blog/${blog?.categories[0]?.slug || 'all'}/${blog.slug}`,
                )
              : undefined
          "
        >
          {{ blog.currentTranslation?.title }}
        </NuxtLink>
      </span>
      <div
        class="ui-text-l text-gray-dark-2"
        v-html="blog.currentTranslation?.short_description"
      />
      <PagesBlogTag
        v-if="blog.categories?.[0]?.currentTranslation?.title"
        :tag="blog.categories?.[0]?.currentTranslation?.title"
        :color="'#303333'"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { format } from "date-fns";
import { Blog } from "ecom-types";
import recoverPasswordImage from "~/assets/images/recoverPassworImage.jpg";

const props = defineProps<{
  blog: Blog;
}>();

const localePath = useLocalePath();
const generalStore = useGeneralStore();

const publishedAt = computed(() => {
  return props.blog?.published_at
    ? format(new Date(props.blog.published_at), generalStore.getSystemDateFormat)
    : "";
});
const image = computed(
  () => props.blog?.medias?.find((el) => el.position === "list") || null,
);
</script>
